// extracted by mini-css-extract-plugin
export var productImage = "_uv-0";